import { ShieldTick, VolumeSlash } from 'iconsax-react';
import { useFriend } from '@/hooks/contacts/use-friends';
import type { ConversationSessionsTypeUnion } from '@/models/conversations/conversation-session';

type Props = {
  session: ConversationSessionsTypeUnion;
};

export default function SessionListItemTitle({ session }: Props) {
  const { friend } = useFriend(session.UserID);

  const isGroup = session.SessionType === 'group';

  return (
    <div className='flex items-center gap-1'>
      <h5 className='line-clamp-1 break-all text-[1.0625rem] leading-6 text-body'>
        {isGroup ? session.GroupName : friend?.RemarkName || friend?.FriendNickName || session.NickName}
      </h5>
      {isGroup && session.GroupType === 1 && (
        <ShieldTick
          variant='Bold'
          className='size-4 text-primary'
        />
      )}
      {session.IsNotDisturb && <VolumeSlash className='size-4 min-w-4 text-secondary' />}
    </div>
  );
}
